import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator, ValidationErrors} from '@angular/forms';
import {createStaticValidator} from './common';

export const Password = createStaticValidator(
  (control: AbstractControl) =>
    !String(control.value)
      .toLowerCase()
      .includes('password'),
  {
    password: true,
  }
);

@Directive({
  selector: '[password]',
  providers: [{provide: NG_VALIDATORS, useExisting: PasswordDirective, multi: true}],
})
export class PasswordDirective implements Validator {
  validate = Password;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/password.validator.ts